import { Fragment } from "react";
import parse from 'html-react-parser';
import RadioButton from "./RadioButton";

type Props = {
    items: Item[];
    checked: number | string | null;
    onCheck: (value: string | number) => void;
    classes?: string;
    separator?: string;
    label?: string;
    description?: string;
    center?: boolean;
    newLine?: boolean;
}

type Item = {
    label: string;
    value: string | number;
}

const RadioGroup = (props: Props) => {
    const { items, checked, onCheck, classes, separator, label, description, center, newLine = false } = props;

    if (items && items.length === 0) return false;

    return (
        <>
            {label ? <label className="form-label">{label}</label> : null}
            {description && <div className="text-muted small mb-2">{parse(description)}</div>}
            <div className={`radio-group d-flex ${newLine ? 'flex-column' : ''} flex-md-row ${center ? 'align-items-center' : ''} ${classes}`}>
                {items && items.map((item: Item, index: number) => (
                    <Fragment key={item.label + index}>
                        {separator && index > 0 ? <span></span> : null}
                        <RadioButton
                            label={item.label}
                            active={checked === item.value}
                            onCheck={onCheck}
                            value={item.value}
                        />
                    </Fragment>
                ))}
            </div>
        </>
    )
}

export default RadioGroup;